import moment from 'moment';
import { of } from 'rxjs';
import { setCookie } from '@bibliocommons/utils-browser';
import ContentWarningConstants, {
  OFFENSIVE_CONTENT_COOKIE_NAME,
  SPOILERS_COOKIE_NAME
} from 'app/constants/ContentWarningConstants';
import { updateUserPreferences } from 'app/api/ContentWarningsApi';
import { selectCurrentUser } from 'app/selectors/AuthSelector';

const {
  SHOW_CONTENT,
  HIDE_CONTENT,
  SHOW_OFFENSIVE_CONTENT_REQUEST,
  SHOW_OFFENSIVE_CONTENT_SUCCESS,
  SHOW_OFFENSIVE_CONTENT_FAILURE,
  HIDE_OFFENSIVE_CONTENT_REQUEST,
  HIDE_OFFENSIVE_CONTENT_SUCCESS,
  HIDE_OFFENSIVE_CONTENT_FAILURE,
  SHOW_SPOILERS_REQUEST,
  SHOW_SPOILERS_SUCCESS,
  SHOW_SPOILERS_FAILURE,
  HIDE_SPOILERS_REQUEST,
  HIDE_SPOILERS_SUCCESS,
  HIDE_SPOILERS_FAILURE
} = ContentWarningConstants;

function composeFlagUpdateApiRequest(newValue, state, client) {
  const currentUserId = state.getIn(['auth', 'currentUserId']);
  if (currentUserId) {
    const currentUser = selectCurrentUser(state);
    // bcRest expects values for both offensive and spoiler flags to be sent in patch requests
    const flags = currentUser.getIn(['preferences', 'flags']).toObject();
    return updateUserPreferences(currentUserId, { flags: { ...flags, ...newValue } }, client);
  }
  return of({});
}

export function toggleContent({ contentId, value }) {
  const type = value ? SHOW_CONTENT : HIDE_CONTENT;
  return {
    contentId,
    type
  };
}

export function toggleOffensiveContent(value) {
  const expires = moment()
    .add(10, 'years')
    .toDate();
  setCookie(OFFENSIVE_CONTENT_COOKIE_NAME, value, { path: '/', expires });

  const types = value
    ? [SHOW_OFFENSIVE_CONTENT_REQUEST, SHOW_OFFENSIVE_CONTENT_SUCCESS, SHOW_OFFENSIVE_CONTENT_FAILURE]
    : [HIDE_OFFENSIVE_CONTENT_REQUEST, HIDE_OFFENSIVE_CONTENT_SUCCESS, HIDE_OFFENSIVE_CONTENT_FAILURE];

  return {
    types,
    apiRequest: (state, client) => composeFlagUpdateApiRequest({ filterOffensive: !value }, state, client)
  };
}

export function toggleSpoilers(value) {
  const expires = moment()
    .add(10, 'years')
    .toDate();
  setCookie(SPOILERS_COOKIE_NAME, value, { path: '/', expires });

  const types = value
    ? [SHOW_SPOILERS_REQUEST, SHOW_SPOILERS_SUCCESS, SHOW_SPOILERS_FAILURE]
    : [HIDE_SPOILERS_REQUEST, HIDE_SPOILERS_SUCCESS, HIDE_SPOILERS_FAILURE];

  return {
    types,
    apiRequest: (state, client) => composeFlagUpdateApiRequest({ filterSpoiler: !value }, state, client)
  };
}

export default { toggleContent, toggleOffensiveContent, toggleSpoilers };
